import { DrawerNavigationOptions } from '@react-navigation/drawer';

export const combineDrawerNavigationOptions = (
  options1: DrawerNavigationOptions,
  options2: DrawerNavigationOptions
): DrawerNavigationOptions => {
  return {
    ...options1,
    ...options2,
    drawerStyle: [options1.drawerStyle, options2.drawerStyle],
    headerStyle: [options1.headerStyle, options2.headerStyle],
    drawerItemStyle: [options1.drawerItemStyle, options2.drawerItemStyle],
    drawerLabelStyle: [options1.drawerLabelStyle, options2.drawerLabelStyle],
  } as DrawerNavigationOptions;
};
